import BaseService from '../baseService'

export class WarehouseService extends BaseService {
  fetchWarehouses() {
    return this.client.get('warehouses').json()
  }
}
